import React, { Component } from 'react'
import { Document, Page, Text, Image, View, StyleSheet } from '@react-pdf/renderer'
import IQrCode from '../../../../../../interfaces/IQrCode'

type QrCode = IQrCode & {
  qrCodeDataUri: string
}
export type PrintQrCodeProps = {
  qrCodes: QrCode[]
}

// Create styles
const styles = StyleSheet.create({
  page: {
    backgroundColor: '#ffffff'
  },
  row: {
    flex: 1,
    flexDirection: 'row',
    flexGrow: 1,
    justifyContent: 'space-between'
  },
  section: {
    margin: 10,
    padding: 10
  }
})

export default class PrintQrCode extends Component<PrintQrCodeProps> {

  private renderContent = (qrCode: QrCode) => {
    const { uuid, title, type_key, branch, qrCodeDataUri } = qrCode

    return (
      <View key={`print-qr-code-${uuid}`} style={styles.section}>
        <Text>Title: {title}</Text>
        <Text>Status: {type_key}</Text>
        {
          branch && <Text>Location: {branch.name}</Text>
        }

        <Image source={qrCodeDataUri} style={{ width: 200, marginTop: 30 }} />
      </View>
    )
  }

  render() {
    const { qrCodes } = this.props

    const columns = Array.from(new Array(Math.ceil(qrCodes.length / 2)), (value, key) => qrCodes.slice(key * 2, key * 2 + 2))

    return (
      <Document>
        <Page size="A4" style={styles.page}>
          {
            columns.map((v, index) => (
              <View key={`row-qr-code-${index}`} style={styles.row}>
                {
                  v.map(v => this.renderContent(v))
                }
              </View>
            ))
          }
        </Page>
      </Document>
    )
  }
}
